import axios from '@/libraries/axios/main';
import ApiResponseOld from '@/interfaces/ApiResponseOld';

export async function fetchArchivedSessions(): Promise<ApiResponseOld> {
  const response = await axios.get(`/session/archived`);

  return response.data;
}

export async function deleteArchivedSession(
  name: string,
): Promise<{ status: string, message: string }> {
  const response = await axios.delete(`/session/archived/delete/${name}`);

  return response.data as { status: string; message: string };
}
